import { render, staticRenderFns } from "./PriceProposalModal.vue?vue&type=template&id=cdda07b2"
import script from "./PriceProposalModal.vue?vue&type=script&lang=js"
export * from "./PriceProposalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports